module.exports = __webpack_public_path__ + "img/ai-tab.909cf42c.png";